import {
  CompanyReportFormValues,
  DefaultName,
} from '@/core/domain/reports/company/Company.types';
import { ReportChecklistCompany } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { isAppPortocar } from '@/index';
import { applyCpfCnpjMask } from '@/utils/mask';
import moment from 'moment';
import { useEffect } from 'react';

interface Props {
  company?: ReportChecklistCompany;
  setLoaded?: (value: boolean) => void;
  companyConfig?: CompanyReportFormValues;
}

const ReportChecklistHeader: React.FC<Props> = ({
  company,
  setLoaded,
  companyConfig,
}) => {
  useEffect(() => {
    if (!company?.filePath) {
      !!setLoaded && setLoaded(true);
    }
  }, [company]);

  return (
    <>
      {isAppPortocar && (
        <div
          className="row gap-40 align-center justify-between with-border p-20 m-b-20"
          style={{ position: 'relative' }}
        >
          <img
            src="/images/Icon-Brand-Porto.svg"
            height={30}
            style={{ zIndex: 1 }}
          />
          <h3
            style={{
              fontSize: 20,
              margin: 0,
              position: 'absolute',
              left: 0,
              width: '100%',
              textAlign: 'center',
            }}
          >
            Relatório de checklist
          </h3>
          <span style={{ zIndex: 1 }}>
            {moment().format('DD/MM/YYYY HH:mm')}
          </span>
        </div>
      )}
      <div className="row gap-40 align-center with-border p-20">
        <img
          src={company?.filePath}
          height="100px"
          onLoad={() => !!setLoaded && setLoaded(true)}
        />

        <div>
          <h3 className="m-0">
            {companyConfig?.companyNaming === DefaultName.fantasyName
              ? company?.nickName
              : company?.name}
          </h3>
          <big>
            <span>{applyCpfCnpjMask(company?.cnpj || '')}</span>
          </big>
        </div>
      </div>
    </>
  );
};

export default ReportChecklistHeader;
